export const getInitialsFromName = name => {
    const initials = name.split(/\s/).map(item => item[0])
    return initials.length > 1 ? [initials[0], initials[initials.length - 1]] : initials
}